import { creatorbase } from '@round/api';
import { formatSnakeCaseToDisplay } from 'helpers';
import StatusBadge, { StatusBadgeTone } from '../StatusBadge/StatusBadge';

/**
 * Blue while it runs, green once every creator is saved, amber when some were not so it reads as a
 * caveat rather than an alarm, and red only when nothing was saved at all.
 */
const STATUS_TONES: Record<creatorbase.CreatorBulkUploadStatus, StatusBadgeTone> = {
    PROCESSING: 'info',
    SUCCEEDED: 'success',
    SUCCEEDED_WITH_ERRORS: 'warning',
    FAILED: 'danger',
};

type Props = {
    status: creatorbase.CreatorBulkUploadStatus;
    className?: string;
};

const BulkUploadStatusBadge = ({ status, className }: Props) => (
    <StatusBadge tone={STATUS_TONES[status]} className={className}>
        {formatSnakeCaseToDisplay(status)}
    </StatusBadge>
);

export default BulkUploadStatusBadge;
